export enum TimePeriod {
  W1 = '1W',
  M1 = '1M',
  M6 = '6M',
  YTD = 'YTD',
  Y1 = '1Y',
  Y3 = '3Y',
  Y5 = '5Y',
  Y10 = '10Y',
  Y15 = '15Y',
  ALL = 'ALL',
}
